// extracted by mini-css-extract-plugin
export default {"marsRocks":"MarsRocks_marsRocks__jrfci","rockBottom":"MarsRocks_rockBottom__5grlS","unchecked":"MarsRocks_unchecked__buAmo"};